"use strict";
var claim_item_model_1 = require("./claim-item.model");
exports.ClaimItemViewModel = claim_item_model_1.ClaimItemViewModel;
var policy_item_view_model_1 = require("./policy-item-view.model");
exports.PolicyItemViewModel = policy_item_view_model_1.PolicyItemViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/claims/index.js